import * as React from 'react';

export default function Close({...rest}) {
  return (
    <svg
      {...rest}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5831 1.441L14.6411 0.5L8.05604 7.10669L1.441 0.5L0.5 1.441L7.11504 8.04769L0.515793 14.6215L1.45679 15.5625L8.05604 8.98869L14.6427 15.5826L15.5847 14.6416L8.99704 8.04769L15.5831 1.441Z"
        fill="#001E50"
      />
    </svg>
  );
}
